export let mappings = {
  '1a': [23,24],
  '1e': [31,32],
  '2a': 25,
  '2d': 26,
  '3b': 27,
  '3c': 28,
  '3d': 29,
  '4e': [30,33]
}